module.exports = {
  "country": "SE",
  "artist": "Loreen",
  "song": "Tattoo",
  "year": "2023",
  "place": "1",
  "spotify": "1DmW5Ep6ywYwxc2HMT5BG6"
};